//src/app/features/questionnaires/edit/TaxQuestionnaire/PersonalDetails/TheBasics/preview.tsx
import { useSelector } from 'react-redux';
import { selectQuestionnaireRoutes } from '../../../routes/slice';
import PreviewCitizenship from './Citizenship/preview';
import PreviewCovidRelief from './CovidRelief/preview';
import PreviewDependents from './Dependents/preview';
import PreviewFamily from './Family/preview';
import PreviewLogistics from './Logistics/preview';
import PreviewName from './Name/preview';
import PreviewPastFillings from './PastFillings/preview';

export interface IPreviewTheBasicsProps {}

export default function PreviewTheBasics(props: IPreviewTheBasicsProps) {
  const routes = useSelector(selectQuestionnaireRoutes).routes;

  return (
    <>
      <h1 className="w-full rounded-t-2xl bg-green text-white px-4  font-semibold pl-6 py-4">
        The Basics
      </h1>
      {routes.personal_details.the_basics.name && <PreviewName />}
      {routes.personal_details.the_basics.citizenship && <PreviewCitizenship />}
      {routes.personal_details.the_basics.past_fillings && (
        <PreviewPastFillings />
      )}
      {routes.personal_details.the_basics.family && <PreviewFamily />}
      {routes.personal_details.the_basics.dependents && <PreviewDependents />}
      {/* {routes.personal_details.the_basics.covid_relief && (
        <PreviewCovidRelief />
      )} */}
      {routes.personal_details.the_basics.logistics && <PreviewLogistics />}
    </>
  );
}
